import React, { useState, useEffect } from "react";
import cx from "classnames";
import styles from "../scss/AppFormField.module.scss";
import { IAnswerProps, IAppFormQuestion } from "../interfaces/IAppFormData";

interface IAFRadioListFieldProps {
    list: IAppFormQuestion[];
    formAnswerList: IAnswerProps[];
    answerChanges: (answerParam: IAnswerProps[]) => void;
    label?: string;
    helpText?: string;
}

const AFRadioListField: React.FC<IAFRadioListFieldProps> = (props) => {
    const { list, answerChanges } = props;
    const [value, setValue] = useState<string>(null);

    const handleFieldValue = (optionId): void => {
        setValue(optionId);
        const returnListValue = list.reduce((acc, item) => {
            return [
                ...acc,
                {
                    questionId: item.id,
                    disclosure: [],
                    answer: item.questionNumber === optionId ? "Yes" : "No",
                    questionNumber: item?.questionNumber
                }
            ];
        }, []);
        answerChanges(returnListValue);
    };

    const handleInitCheckList = (): void => {
        const activeOption = list.find((i) => i.answer === "Yes");
        if (activeOption?.questionNumber) {
            handleFieldValue(activeOption?.questionNumber);
        }
    };

    useEffect(() => {
        if (list?.length) {
            handleInitCheckList();
        }
    }, []);

    return (
        <div className={styles["af-checkboxlist"]}>
            <fieldset
                id={props?.label}
                className={cx([
                    styles["af-radio-button"],
                    list.length >= 6 ? styles["with--two-columns"] : ""
                ])}>
                <legend>{props?.label}</legend>
                {props?.helpText &&
                    <p className="text-help">{props?.helpText}</p>
                }
                {list.map((opt, idx) => (
                    <div className={styles["radiolist-button-l"]} key={idx}>
                        <input
                            type="radio"
                            id={`radiocontrol-${idx}`}
                            name="radioControl"
                            value={opt.questionNumber}
                            checked={value === opt.questionNumber}
                            onChange={() => {
                                handleFieldValue(opt.questionNumber);
                            }}
                        />
                        <label
                            className={styles["radion-button--label-container"]}
                            htmlFor={`radiocontrol-${idx}`}>
                            <div
                                className={styles["rb--label"]}
                                dangerouslySetInnerHTML={{
                                    __html: opt.questionText || ""
                                }}></div> 
                        </label>
                    </div>
                ))}
            </fieldset>
        </div>
    );
};

export default AFRadioListField;
